import {addStatsHealth, Stats} from "./Stats";
import {Room} from "./Room";
import {CardConfig, CardType, StatType} from "./CardTypes";
import {GameConfig} from "../config/GameConfig";

export function applyCardEffect(scene: Phaser.Scene, cardConfig: CardConfig, stats: Stats, currentRoom: Room): void {
    (scene as any).addCardConfig(cardConfig);
    (scene as any).lock(cardConfig)
    currentRoom.showEffect(cardConfig);

    if (cardConfig.type === CardType.INCREASE_STAT && cardConfig.statType) {
        switch (cardConfig.statType) {
            case StatType.SANCTUARY:
                if (stats.health < stats.maxHealth) {
                    ;(scene as any).getPlayer().startBoosting(0xccffcc)
                    scene.sound.play('sound_sanctuary', {
                        loop: false,
                        volume: 0.2
                    })
                }
                break;
            case StatType.FORGE:
                if (stats.gold >= GameConfig.forge.gold) {
                    ;(scene as any).getPlayer().startBoosting(0xbbeeff)
                    scene.sound.play('sound_forge', {
                        loop: false,
                        volume: 0.2
                    })
                }
                break;
        }

        scene.time.delayedCall(1000, () => {
            switch (cardConfig.statType) {
                case StatType.SANCTUARY:
                    addStatsHealth(stats, Math.round(stats.maxHealth * GameConfig.sanctuary.healPercent * 0.01))
                    break;
                case StatType.FORGE:
                    while (stats.gold >= GameConfig.forge.gold) {
                        stats.attack += GameConfig.forge.attack
                        stats.maxHealth += GameConfig.forge.health
                        stats.crit += GameConfig.forge.crit

                        if (GameConfig.forge.healOnHealthIncrease) {
                            addStatsHealth(stats, GameConfig.forge.health)
                        }

                        stats.speed = Math.min(stats.speed + GameConfig.forge.speed, GameConfig.forge.maxSpeed)
                        stats.gold -= GameConfig.forge.gold

                        if (!GameConfig.forge.multirepeat) {
                            break
                        }
                    }
                    break;
            }

            (scene as any).startAutoMovement();
            (scene as any).unlock(cardConfig)
        });
    } else if (cardConfig.type === CardType.CREATE_MONSTER) {
        (scene as any).startFight(cardConfig.monsterType);
        (scene as any).unlock(cardConfig)
    }
}